import { Modal } from "antd";

import _ from "../../../i18n";
import styles from "./UserRoleModal.module.scss";
import contactStyles from "./Contact.module.scss";

const UserGroupModal = ({ modalOpen, closeModal, item }) => {
  return (
    <>
      <Modal
        width="60vw"
        height="50vh"
        closable={false}
        open={modalOpen}
        footer={null}
        onCancel={(e) => {
          e.stopPropagation();
          closeModal();
        }}
        maskClosable={false}
        destroyOnClose={true}
        keyboard={false}
      >
        <div className={styles.modal_header}>
          Groupes de :{" "}
          {`${item.lastName ? item.lastName : ""} ${
            item.firstName ? item.firstName : ""
          }`}
          {(item.lastName !== undefined && item.lastName !== "") ||
            (item.firstName !== undefined && item.firstName !== "")}{" "}
        </div>
        <div
          className={styles.modal_close}
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
        >
          <i className="icon-ttp-close"></i>
        </div>

        <div className={styles.modal_body} style={{ fontSize: "12px" }}>
          {item.groups.map((i) => (
            <span className={contactStyles.groupName}>{i.name}</span>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default UserGroupModal;
